import { render, staticRenderFns } from "./LevelUpDialog.vue?vue&type=template&id=ded506f8&scoped=true&"
import script from "./LevelUpDialog.vue?vue&type=script&lang=ts&"
export * from "./LevelUpDialog.vue?vue&type=script&lang=ts&"
import style0 from "./LevelUpDialog.vue?vue&type=style&index=0&id=ded506f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded506f8",
  null
  
)

export default component.exports